import classnames from 'classnames';
import {getSetting} from '@woocommerce/settings'

/**
 * Generalized tokenized payment method component
 * Can be used by any payment integration (Fastlane, Google Pay, etc.)
 */
export const TokenizedPaymentMethod = (
    {
        alt,
        type,
        description,
        actions = [],
        className = ''
    }
) => {
    const icons = getSetting('ppcpGeneralData').cardIcons;
    return (
        <div className={classnames('wc-ppcp-tokenized-card', className)}>
            {type && (
                <CardIcon alt={alt} src={icons[type]}/>
            )}
            <div className="wc-ppcp-tokenized-card-format">
                {description}
            </div>
            {actions.length > 0 && (
                <div className="wc-ppcp-tokenized-card-actions">
                    {actions.map((action, index) => (
                        <a
                            key={index}
                            className={`wc-ppcp-tokenized-card-${action.type || 'action'}`}
                            onClick={action.onClick}>
                            {action.label}
                        </a>
                    ))}
                </div>
            )}
        </div>
    )
}

const CardIcon = ({src, alt}) => {
    return (
        <div className="wc-ppcp-tokenized-card-icon-container">
            <img src={src} alt={alt || ''}/>
        </div>
    )
}

export default TokenizedPaymentMethod;